import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { urgency } from '../data/masterclass';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section aria-labelledby="urgency-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-153" data-mp="1wzf3zcvbyafu">
      <div className="mx-auto w-full max-w-5xl px-6 py-20 lg:py-28" data-id="element-154" data-mp="21y88wgwjwt4e">
        <h2 id="urgency-heading" className="max-w-3xl font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-155" data-mp="220ktz2xlvjlo">
          Don’t wait for the crack.{' '}
          <span className="text-gold" data-id="element-156" data-mp="1szmtgumdlu7u">Check the foundation.</span>
        </h2>

        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/65" data-id="element-157" data-mp="1eaql0wgeqf6p">
          {urgency.intro}
        </p>

        <ul className="mt-10 divide-y divide-ink-line border-y border-ink-line" data-id="element-158" data-mp="1j5nrpwq7scgf">
          {urgency.lines.map(line => <li key={line} className="py-4 text-xl text-white/75" data-id="element-159" data-mp="199kosonjg9sf">
              {line}
            </li>)}
        </ul>

        <p className="mt-8 font-display text-2xl font-semibold uppercase leading-snug text-white sm:text-3xl" data-id="element-160" data-mp="25xz6ykvo130y">
          {urgency.close}
        </p>

        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/70" data-id="element-161" data-mp="2fxgaowrcx6ua">
          {urgency.final}
        </p>

        <div className="mt-14 flex flex-col items-start gap-10 border-t border-gold/20 pt-10 lg:flex-row lg:items-center lg:justify-between" data-id="element-162" data-mp="2aymz59vmrpwr">
          <Countdown data-id="element-163" data-mp="1n9aos6okhbsv" />
          <a href="#pricing" className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-gold px-9 py-5 text-sm font-bold uppercase tracking-[0.12em] text-ink transition-[transform,background-color] duration-200 ease-out hover:bg-gold-pale focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold active:scale-[0.98]" data-id="element-164" data-mp="1n6ol4i4srgfx">
            Check our foundation
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-165" data-mp="zjzv195mwho8" />
          </a>
        </div>
      </div>
    </section>;
}